import woothee from "woothee";

export default {
    isPcUser(ua) {
        const parser = woothee.parse(ua);
        return parser.category === 'pc';
    },
    isValidUa(ua) {
        const parser = woothee.parse(ua);
        return parser.os !== "Android" || parser.name === 'Chrome';
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/ua.js